import { useCacheBuster } from "react-cache-buster";
import { useState } from "react";
import { createPortal } from "react-dom";
import { forceReload } from "@/utils/browserUtils";

const VersionCheckButton = ({ children }) => {
  const { checkCacheStatus } = useCacheBuster();
  const [modalOpen, setModalOpen] = useState(false);
  const [modalContent, setModalContent] = useState({
    title: "",
    description: "",
  });

  const handleClick = async () => {
    try {
      const result = await checkCacheStatus();
      if (result) {
        setModalContent({
          title: "🚀 New Version Available!",
          description: `A new version of the app has been released. This version includes new features, bug fixes, 
          and performance improvements. You can reload the page to experience the latest updates instantly.`,
        });
      } else {
        setModalContent({
          title: "✅ You Are Up-to-date",
          description: `Your app is running the latest version. No updates are currently available. 
          Check back later for new features and improvements.`,
        });
      }
      setModalOpen(true);
    } catch (err) {
      console.error(err);
      setModalContent({
        title: "❌ Version Check Failed",
        description: `We could not check the latest version due to a network or system error. 
        Please try again later.`,
      });
      setModalOpen(true);
    }
  };

  const closeModal = () => {
    setModalOpen(false);
    forceReload();
  };


  return (
    <>
      <button
        type="button"
        onClick={handleClick}
        className="text-blue-400 no-underline hover:underline hover:text-blue-500 ml-1"
        style={{
          background: "none",
          border: "none",
          padding: 0,
          cursor: "pointer",
        }}
      >
        {children}
      </button>

      {modalOpen &&
        createPortal(
          <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/70 bg-opacity-50">
            <div className="bg-white dark:bg-gray-800 rounded-lg shadow-xl max-w-lg w-full mx-4 md:mx-0 p-6 text-center animate-fadeIn scale-up">
              {/* Title with icon and colored background */}
              <div className="bg-blue-500 dark:bg-blue-600 rounded-t-lg p-4 mb-4 flex items-center justify-center">
                <span className="text-2xl mr-2">
                  {modalContent.title.startsWith("🚀") ? "🚀" : "ℹ️"}
                </span>
                <h2 className="text-lg font-semibold text-white">
                  {modalContent.title.replace(/^[^ ]+ /, "")}
                </h2>
              </div>

              {/* Description */}
              <div className="text-gray-700 dark:text-gray-200 text-left max-h-80 overflow-y-auto mb-6 px-2">
                <p>{modalContent.description}</p>
              </div>

              {/* Buttons */}
              <div className="flex justify-center gap-4">
                <button
                  onClick={forceReload}
                  className="px-5 py-2 bg-blue-500 text-white rounded hover:bg-blue-600 transition font-medium"
                >
                  Reload
                </button>
                <button
                  onClick={closeModal}
                  className="px-5 py-2 bg-gray-200 dark:bg-gray-700 text-gray-800 dark:text-gray-200 rounded hover:bg-gray-300 dark:hover:bg-gray-600 transition font-medium"
                >
                  Close
                </button>
              </div>
            </div>
          </div>,
          document.body
        )}
    </>
  );
};

export default VersionCheckButton;
